// page/WMS/WMS/router.js
// WMS菜单下管理的路由文件
import Vue from 'vue' 
export default [
	{
		path: '/personnelEmployeefile',
		component: () => import('./Employeefile.vue'),
		name:'Employeefile',
		meta: {
			title:'Sidebar.personnelsubsTitle[0]'
		}
	},
	{
		path: '/personnelDepartment',
		component: () => import('./Department.vue'),
		name:'Department',
		meta: {
			title:'Sidebar.personnelsubsTitle[1]'
		}
	},{
		path: '/DepartmentGoodsStock',
		component: () => import('./DepartmentGoodsStock.vue'),
		name:'DepartmentGoodsStock',
		meta: {
			title:'Sidebar.personnelsubsTitle[2]'
		}
	},{
		path: '/DepartGroupSetting',
		component: () => import('./DepartGroupSetting.vue'),
		name:'DepartGroupSetting',
		meta: {
			title:'Sidebar.personnelsubsTitle[3]'
		}
	}
];



// WEBPACK FOOTER //
// ./src/components/page/Personnel/router.js